export default __webpack_public_path__ + "f17ed9ca66bccaeb84e1a3038d7bac02.svg";